// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./Menu.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { MenuRoot } from "../_internal_menu";

const styles = [
  {
    type: "default",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
];

const variantPropTypes = [];

export const MenuContext = createContext(null);

function Menu(_props) {
  const defaults = useContext(MenuContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <MenuRoot
      {...props}
      key="menu-root"
      internal={{
        styles,
        projectId: "7X7HTLRqyD",
        layerId: "menu-root",
        scope: "42w7irSvds",
        activeVariants,
      }}
    >
      {props.children}
    </MenuRoot>
  );
}

Menu.__variants = [];

export default Menu;
